import { render, staticRenderFns } from "./OrdersScheduleMeal.vue?vue&type=template&id=08e8064a&scoped=true"
import script from "./OrdersScheduleMeal.vue?vue&type=script&lang=js"
export * from "./OrdersScheduleMeal.vue?vue&type=script&lang=js"
import style0 from "./OrdersScheduleMeal.vue?vue&type=style&index=0&id=08e8064a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e8064a",
  null
  
)

export default component.exports